import { render, staticRenderFns } from "./detail_orgStructure.vue?vue&type=template&id=5231ca4a&scoped=true&"
import script from "./detail_orgStructure.vue?vue&type=script&lang=js&"
export * from "./detail_orgStructure.vue?vue&type=script&lang=js&"
import style0 from "./detail_orgStructure.vue?vue&type=style&index=0&id=5231ca4a&prod&lang=css&"
import style1 from "./detail_orgStructure.vue?vue&type=style&index=1&id=5231ca4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231ca4a",
  null
  
)

export default component.exports